import React from 'react';
import { Leaf, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function IntroSection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-160">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5 pointer-events-none" data-id="element-161">
        <Leaf className="absolute -top-24 -left-24 w-96 h-96 text-[#1B4332] transform -rotate-45" data-id="element-162" />
        <Leaf className="absolute top-1/2 -right-24 w-64 h-64 text-[#1B4332] transform rotate-45" data-id="element-163" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1B4332]/10 text-[#1B4332] mb-8" data-id="element-166">
            <Leaf size={32} data-id="element-167" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6 leading-tight" data-id="element-168">
            Introducing I&A Landscaping LLC
          </h2>
          <p className="text-xl md:text-2xl text-[#1B4332] font-medium mb-12" data-id="element-169">
            Northeast Ohio's Full-Service Outdoor Transformation Experts
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg text-gray-700 space-y-6 text-left max-w-3xl mx-auto" data-id="element-170">
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10 text-center" data-id="element-171">
            <span className="px-6 py-3 bg-gray-50 rounded-lg border border-gray-100 font-medium text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-172">
              We're not a lawn care company.
            </span>
            <span className="px-6 py-3 bg-gray-50 rounded-lg border border-gray-100 font-medium text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-173">
              We're not just a concrete crew.
            </span>
          </div>

          <p className="text-2xl text-center font-serif text-gray-900 mb-10" data-id="element-174">
            We are a{' '}
            <strong className="text-[#1B4332]" data-id="element-175">
              complete outdoor transformation team
            </strong>{' '}
            — and we handle everything your property needs, from the ground up.
          </p>

          <div className="bg-[#FEFAE0] p-8 rounded-2xl border border-[#D4A373]/30 shadow-sm" data-id="element-176">
            <p className="mb-6 leading-relaxed" data-id="element-177">
              Whether you want a stunning paver patio where your family can
              gather on summer evenings… elegant outdoor lighting that makes
              your home glow at night… a lush, professionally designed landscape
              that turns heads every time someone drives by… or a custom
              concrete project built to last decades —
            </p>
            <div className="flex items-center gap-3 text-2xl font-bold text-[#1B4332]" data-id="element-178">
              <Check size={28} className="text-[#D4A373]" data-id="element-179" />
              <span data-id="element-180">We do it all. And we do it right.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}